<template>
	<div id="body">
		<div class="overlay">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<div class="page-title wow bounceInLeft" ata-wow-delay="0.4s" style="visibility: visible; animation-name: bounceInLeft;">
							<h1>{{home}}</h1></div>
					</div>
					<div class="col-md-6 col-sm-6">
						<ul class="page-breadcrumb wow bounceInRight" ata-wow-delay="0.4s" style="visibility: visible; animation-name: bounceInRight;">
							<li>
								<router-link to="/programme">{{home}}</router-link>
							</li>
							<li class="active">
								<a href="javascript:;">{{title}}</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="page-seperate"></div>
		<div id="content">
			<section class="blog-section">
				<div class="container">
					<div class="row">
						<!--Blog Section-->
						<!--<div class="col-md-8 col-sm-7 col-xs-12">-->
						<div class="col-md-12 col-sm-12 col-xs-12">
							<article id="post-82" class="post-82 post type-post status-publish format-standard hentry category-uncategorized" data-wow-delay="0.4s">
								<div class="entry-meta">
									<span class="entry-date">
										<a href="javascript:;"><time datetime="">{{value.date}}</time></a>
									</span>
								</div>
								<header class="entry-header">
									<h3 class="entry-title"><a href="javascript:;">{{value.title}}</a></h3>
									<div class="entry-meta">
										<span class="author">{{lang == 1 ? '作者' : 'Author'}} <a rel="tag" href="javascript:;">{{value.author_name}}</a></span>
										<span class="cat-links">{{lang == 1 ? '在' : 'in'}}<a href="javascript:;" rel="category tag">{{value.category}}</a></span>
									</div>
								</header>
								<div class="entry-content">
									<figure class="wp-block-image size-large is-resized">
										<figcaption style="display: block;" v-html="value.content"></figcaption>
									</figure>
								</div>
							</article>
							<article class="blog-author wow fadeInDown" data-wow-delay="0.4s">
								<div class="media">
									<div class="pull-left">
										<img alt='' src='../assets/admin.jpg' class='img-responsive img-circle avatar-200 photo' height='200' width='200' loading='lazy' />
									</div>
									<div class="media-body">
										<h6><a href="javascript:;" title="" rel="author external">{{value.author_name}}</a></h6>
										<p></p>
										<ul class="blog-author-social"></ul>
									</div>
								</div>
							</article>
							<article class="comment-form-section wow fadeInDown" data-wow-delay="0.4s">
								<div id="respond" class="comment-respond">
									<h3 id="reply-title" class="comment-reply-title">
										<div class="comment-title">
											<h3><i class="fa fa-comment-o"></i>发表评论</h3>
								</div>
								<small><a rel="nofollow" id="cancel-comment-reply-link" href="" style="display:none;">取消回复</a></small>
								</h3>
								<form action="" method="post" id="submit" class="form-inline">
									<input type="hidden" name="article_id" :value="id" />
									<div class="blog-form-group-textarea">
										<textarea id="comments" name="content" placeholder="信息" class="blog-form-control-textarea" rows="5" v-model="content"></textarea>
									</div>
									<div class="blog-form-group">
										<input type="text" name="name" id="author" placeholder="名称" class="blog-form-control" v-model="name">
									</div>
									<div class="blog-form-group">
										<input type="text" name="email" id="email" placeholder="电子邮件" class="blog-form-control" v-model="email">
									</div>
									<p class="comment-form-cookies-consent">
										<input id="wp-comment-cookies-consent" name="wp-comment-cookies-consent" type="checkbox" value="yes" />
										<label for="wp-comment-cookies-consent">在此浏览器中保存我的名字、电邮和网站。</label>
									</p>
									<p class="form-submit">
										<input name="submit" type="submit" id="blogdetail-btn" class="blogdetail-btn" value="发送信息" />
									</p>
								</form>
						</div>
						</article>
					</div>
					<!--/Blog Section-->
					<!--Sidebar Section-->
					<!--<div class="col-md-4 col-sm-5 col-xs-12">
						<div class="sidebar">
							<aside id="search-1" class="widget widget_search wow fadeInDown" data-wow-delay="0.4s">
								<div class="section-header wow fadeInDown" data-wow-delay="0.4s">
									<h3 class="widget-title">Search</h3></div>
								<form method="get" id="searchform" class="search-form" action="" ref="form">
									<label><input type="search" class="search-field" :placeholder="lang == 1 ? '搜索' : 'Search'" v-model="search" /></label>
									<label><input type="button" class="search-submit" :value="lang == 1 ? '搜索' : 'Search'" @click="onSubmit"></label>
								</form>
							</aside>
							<aside id="recent-posts-1" class="widget widget_recent_entries wow fadeInDown" data-wow-delay="0.4s">
								<div class="section-header wow fadeInDown" data-wow-delay="0.4s">
									<h3 class="widget-title">{{lang == 1 ? '近期文章' : 'Latest Release' }}</h3></div>
								<ul>
									<li v-for="item in right">
										<router-link :to="{name:'article',params: { id: item.article_id }}">{{item.title}}</router-link>
									</li>
								</ul>

							</aside>
						</div>
					</div>-->
					<!--Sidebar Section-->
				</div>
		</div>
		</section>
	</div>
	</div>
</template>

<script>
	import { getArticle, getArticleDetail, getArticleComment, addArticleComment } from '../api/api';
	import { WOW } from 'wowjs';
	export default {
		data() {
			return {
				loading: false,
				show: false,
				baseUrl: 'http://admin.brlsea.org',
				title: '',
				id: '',
				right: [],
				search: '',
				value: '',
				name: '',
				email: '',
				content: '',
				home: ''
			};
		},
		props: ['lang'],
		watch: {
			$route(to, from) {
				let that = this;
				this.id = this.$route.params.id;
				this.show = false;
				this.onGetArticleRight();
				this.onGetData();
			},
		},
		methods: {
			onSubmit() {
				this.$router.push({
					name: 'search',
					params: {
						search: this.search
					}
				})
			},
			onGetData() {
				let that = this;
				getArticleDetail({
					lang: this.lang,
					article_id: this.id,
				}).then(res => {
					if(res.code == 1) {
						that.title = res.data.title;
						document.title = res.data.title;
						that.show = true;
						that.value = res.data;
					}
				})
			},
			onGetArticleRight() {
				let that = this;
				getArticle({
					lang: this.lang,
					page: 1,
					size: 3
				}).then(res => {
					if(res.code == 1) {
						that.right = res.data;
					}
				})
			},
			onRegistPost() {
				let that = this;
				let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
				if(this.content == '') {
					alert('信息不能为空');
				} else if(this.name == '') {
					alert('名称不能为空');
				} else if(this.name.length > 30) {
					alert('名称长度不能大于30个字符');
				} else if(this.email == '') {
					alert('请输入邮箱');
				} else if(!reg.test(this.email)) {
					alert('邮箱格式不合法');
				} else {
					$.ajax({
						type: "POST",
						dataType: "json",
						url: "http://admin.brlsea.org/api/index/addArticleComment",
						data: $('#submit').serialize(),
						success: function(res) {
							that.loading = false;
							if(res.code == 1) {
								if($("#wp-comment-cookies-consent").prop("checked") == true) {
									let user = {
										"name": that.name,
										"email": that.email
									}
									user = JSON.stringify(user);
									window.localStorage.setItem('user', user);
								} else {
									window.localStorage.removeItem('user')
								}
							}
							alert(res.msg);
							that.$router.go(0);
						}
					});
				}
			},
		},
		created() {
			let that = this;
			this.id = this.$route.params.id;
			this.onGetData();
			this.onGetArticleRight();
			if(window.localStorage.getItem('user')) {
				let user = JSON.parse(window.localStorage.getItem('user'));
				this.name = user.name;
				this.email = user.email;
			}
			$('body').on('submit', '#submit', function() {
				event.preventDefault() //阻止form表单默认提交
				if(that.loading){
					return false;
				}
				that.loading = true;
				that.onRegistPost()
			})
		},
		mounted() {
			this.home = $(".menu-item.active a").text();
			setTimeout(()=>{
				new WOW().init()
			},100)
		}
	};
</script>

<style scoped="scoped">

</style>


// WEBPACK FOOTER //
// src/components/comm_article.vue